import React from "react";
import moment from "moment";
import { getImage } from "../../../../../../utils/getImages";
import "./app.css";

const VlogThumbnailPreview = ({ cardData, activetab, rootData }) => {
  const image =
    activetab === "simplified_chinese"
      ? cardData?.simplified_chinese_image || cardData?.image
      : activetab === "treditonal_chinese"
      ? cardData?.traditional_chinese_image || cardData?.image
      : activetab === "bahasa"
      ? cardData?.bahasa_image || cardData?.image
      : cardData?.image;

  const title =
    activetab === "simplified_chinese"
      ? cardData?.simplified_chinese_title
      : activetab === "treditonal_chinese"
      ? cardData?.traditional_chinese_title
      : activetab === "bahasa"
      ? cardData?.bahasa_title
      : cardData?.title;

  const description =
    activetab === "simplified_chinese"
      ? cardData?.simplified_chinese_description
      : activetab === "treditonal_chinese"
      ? cardData?.traditional_chinese_description
      : activetab === "bahasa"
      ? cardData?.bahasa_description
      : cardData?.description;

  return (
    <div style={{ margin: "20px" }}>
      <div
        style={{
          display: "flex",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          overflow: "hidden",
          background: "#fff",
          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
        }}
      >
        <div style={{ width: "42%", minHeight: "180px", flexShrink: 0 }}>
          {image ? (
            <img
              src={getImage(image)}
              alt={title || ""}
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            />
          ) : (
            <div
              style={{
                width: "100%",
                height: "100%",
                minHeight: "180px",
                background: "#e0e0e0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span style={{ color: "#999", fontSize: "12px" }}>No Image</span>
            </div>
          )}
        </div>

        <div style={{ padding: "20px 24px", flex: 1 }}>
          {rootData?.date && (
            <p
              style={{
                fontSize: "11px",
                fontWeight: "600",
                color: "#555",
                letterSpacing: "0.5px",
                textTransform: "uppercase",
                marginBottom: "8px",
              }}
            >
              {moment(rootData.date).format("DD MMM YYYY")}
            </p>
          )}
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "700",
              color: "#1a2e5a",
              lineHeight: "1.4",
              marginBottom: "10px",
            }}
          >
            {title || <span style={{ color: "#bbb" }}>No Title</span>}
          </h3>
          <p
            style={{
              fontSize: "13px",
              color: "#555",
              lineHeight: "1.5",
              margin: 0,
            }}
          >
            {description || ""}
          </p>
        </div>
      </div>
    </div>
  );
};

export default VlogThumbnailPreview;
